import Vue from 'vue'
import hash from 'object-hash'
import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => ({ ...createPlatformState(), venues: {} }),
  actions: {
    async fetchRules ({ commit }, id) {
      const rules = await platformAction({
        client: this.$api.content.houseRules,
        method: 'getAll',
        params: {
          filter: {
            venue_id: id
          }
        },
        commit,
        logError: this.$logError,
        include: []
      })

      commit('saveSearch', { id, rules })
    }
  },
  getters: {
    ...platformGetters,
    getRulesByHouse: s => id => {
      const hashedSearch = hash(id)
      const thisSearch = s.venues[hashedSearch]

      if (!thisSearch) {
        return []
      }

      return thisSearch.rules
    }
  },
  mutations: {
    ...platformMutations,
    saveSearch: (s, { id, rules }) => {
      const hashedSearch = hash(id)
      const search = { rules }
      Vue.set(s.venues, hashedSearch, search)
    }
  }
}
